<template>
   <div class="card p-2">
        <div class="filtros">
            <b-row>
                <b-col lg="3" md="12" sm="12">
                    <b-form-group 
                            label="DR" 
                            label-for="dr" 
                            label-class="font_size_label"
                        >
                        <v-select
                            id="dr"
                            placeholder="Selecione uma DR"
                            label="descricao"
                            :options="drSelect"
                            value="id_departamento"
                            v-model="idDrSelected"
                            :disabled="loadingCompanies"
                            v-b-tooltip.hover.top="idDrSelected && idDrSelected.descricao ? idDrSelected.descricao : ''"
                            @input="handleDrChange"
                        >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="12" sm="12">
                    <b-form-group 
                            label="Campanha" 
                            label-for="campanha" 
                            label-class="font_size_label"
                        >
                        <v-select
                            id="campanha"
                            placeholder="Selecione uma campanha"
                            label="campanha_descricao"
                            :options="campanhaSelect"
                            value="id_campanha"
                            v-model="idCampanhaSelected"
                            :disabled="!idDrSelected || loadingCompanies"
                            v-b-tooltip.hover.top="idCampanhaSelected && idCampanhaSelected.campanha_descricao ? idCampanhaSelected.campanha_descricao : ''"
                        >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="12" sm="12">
                    <b-form-group 
                            label="Unidade Operacional" 
                            label-for="unidade" 
                            label-class="font_size_label"
                        >
                        <v-select
                            id="unidade"
                            placeholder="Selecione uma unidade"
                            label="descricao_unidade"
                            :options="unidadeSelect"
                            value="id_unidade"
                            v-model="idUnidadeSelected"
                            :disabled="!idDrSelected || loadingCompanies"
                            v-b-tooltip.hover.top="idUnidadeSelected && idUnidadeSelected.descricao_unidade ? idUnidadeSelected.descricao_unidade : ''"
                        >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="2" md="12" sm="12" class="d-flex align-items-end mb-1">
                    <b-button 
                    id="search_companies"
                    variant="custom-blue"
                    @click.prevent="searchCompanies"
                    :disabled="isDisabled"
                    class="col-lg-12"
                    >
                    <feather-icon icon="CheckIcon" class="mr-50"/>
                    <span class="align-middle">Pesquisar</span>
                    <span v-if="loadingCompanies" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <b-alert v-if="enderecosNaoEncontrados.length > 0 && !loadingCompanies" variant="warning" show class="mb-2">
            <div class="d-flex justify-content-between align-items-center m-1">
                <div class="d-flex align-items-center">
                    <feather-icon icon="AlertTriangleIcon" class="mr-1" size="20" />
                    <span>
                        <strong>{{ enderecosNaoEncontrados.length }} endereço(s) não foram encontrados no mapa.</strong>
                        Clique no botão ao lado para baixar a lista.
                    </span>
                </div>
                <b-button variant="warning" size="sm" @click="downloadAddressesNotFound">
                    <feather-icon icon="DownloadIcon" class="mr-50" />
                    Baixar Excel
                </b-button>
            </div>
        </b-alert>
        <AgendamentoGoogleMaps
            :markersData="enderecos"
            @clickMarker="chooseCompanyToAgendamento"
        />
        <b-row class="d-flex" :class="selectedAdress ? 'justify-content-between' : 'justify-content-end'">
            <b-col lg="4" md="12" sm="12" class="mb-2 mb-lg-0">
                <b-button 
                      v-if="selectedAdress"
                      id="select-empresa"
                      variant="custom-blue"
                      @click.prevent="emitCompanyToAgendamento"
                      class="col-12 col-lg-9"
                    >
                        <feather-icon icon="CheckIcon" class="mr-50"/>
                        <span class="align-middle">Gerar Novo Agendamento</span>
                </b-button>
            </b-col>
            <b-col lg="6" md="12" sm="12" class="d-flex justify-content-end">
                <MapPointers v-if="enderecos.length > 0" />
            </b-col>
        </b-row>
   </div>
</template>

<script>
import vSelect from 'vue-select';
import { BFormGroup, BCol, BRow, BButton, BAlert, VBTooltip } from "bootstrap-vue";
import AgendamentoGoogleMaps from '@/views/charts-and-maps/maps/google/AgendamentoGoogleMaps.vue';
import MapPointers from '@/views/custom-pages/agendamento/components/MapPointers.vue';

export default {
    components: {
        AgendamentoGoogleMaps,
        vSelect,
        BFormGroup,
        BCol,
        BRow,
        MapPointers,
        BButton,
        BAlert,
        VBTooltip
    },
    data() {
        return {
            drSelect: [],
            campanhaSelect: [],
            unidadeSelect: [],
            idDrSelected: null,
            idCampanhaSelected: null,
            idUnidadeSelected: null,
            enderecos: [],
            enderecosNaoEncontrados: [],
            selectedAdress: null,
            loadingCompanies: false
        }
    },
    mounted() {
        this.populateFields();
    },
    computed: {
        isDisabled() {
            return !this.idDrSelected || !this.idCampanhaSelected;
        }
    },
    methods: {
        populateFields() {
            this.$http.get(this.$api.departamento()).then(({ data }) => {
                this.drSelect = data;
            });
        },
         handleDrChange() {
            this.searchCampaign();
            this.searchUnit();
        },
        searchCampaign(){
            if (!this.idDrSelected) {
                this.campanhaSelect = [];
                this.idCampanhaSelected = null;
                return;
            }

            this.$http.get(this.$api.campanha(), { params: { situacao: ['Em andamento', 'Concluída'] } }).then(({ data }) => {
                this.campanhaSelect = data;
            })
        },
        searchUnit() {
            if (!this.idDrSelected) {
                this.unidadeSelect = [];
                this.idUnidadeSelected = null;
                return;
            }

            this.$http.get(this.$api.unidade(), { params: { id_departamento: this.idDrSelected.id_departamento, ativo: true  } }).then(({ data }) => {
                const unidades = data;

                this.unidadeSelect = [
                    { id_unidade: null, descricao_unidade: "Todas as Unidades" },
                    ...unidades,
                ];
            });
        },
        async searchCompanies() {
            this.enderecos = [];
            this.enderecosNaoEncontrados = [];
            this.selectedAdress = null;

            if(!this.idCampanhaSelected) {
                return;
            }

            this.loadingCompanies = true;

            const { data } = await this.loadAgendamentoEmpresa();

            this.enderecos = data
            this.enderecosNaoEncontrados = data.filter(endereco => !endereco.latitude && !endereco.longitude)

            await this.searchAdressesLocalization(this.enderecosNaoEncontrados);

            this.enderecosNaoEncontrados = this.enderecos.filter(
                endereco => !endereco.latitude && !endereco.longitude
            )

            this.enderecos = this.enderecos.filter(
                endereco => endereco.latitude && endereco.longitude
            )

            this.loadingCompanies = false;
        },
        async loadAgendamentoEmpresa(){
            const params = {};

             if (this.idUnidadeSelected && this.idUnidadeSelected?.id_unidade !== null) {
                params.idsUnidade = [this.idUnidadeSelected.id_unidade];
            }

            return await this.$http.get(
                this.$api.agendamentoEmpresaCampanha(this.idCampanhaSelected.id_campanha),
                { params }
            );
        },
        async searchAdressesLocalization(enderecos) {
            const cacheFalhos = JSON.parse(localStorage.getItem('enderecosFalhos') || '[]')

            const enderecosParaTentar = enderecos.filter(
                e => !cacheFalhos.includes(e.id_empresa_endereco)
            )

            for (const endereco of enderecosParaTentar) {
                const latLng = await this.$geoLocationService.getCoordinatesFromAddress(
                    {
                        logradouro: endereco.logradouro,
                        numero: endereco.numero,
                        bairro: endereco.bairro,
                        cidade: endereco.cidade,
                        estado: endereco.estado,
                        cep: endereco.cep,
                    }
                )

                if (latLng?.lat && latLng?.lng) {
                    endereco.latitude = latLng.lat;
                    endereco.longitude = latLng.lng;

                    await this.$http.patch(this.$api.patchCoordenadasEnderecoEmpresa(endereco.id_empresa_endereco), {
                        latitude: endereco.latitude,
                        longitude: endereco.longitude
                    });
                } else {
                    cacheFalhos.push(endereco.id_empresa_endereco)
                    localStorage.setItem('enderecosFalhos', JSON.stringify([...new Set(cacheFalhos)]))
                }
            }
        },
        chooseCompanyToAgendamento(endereco) {
            this.selectedAdress = endereco
        },
        emitCompanyToAgendamento() {
            this.$emit('companyToAgendamento', 
            {
                ...this.selectedAdress,
                id_campanha: this.idCampanhaSelected.id_campanha
            }
            );
        },
        downloadAddressesNotFound() {
            if (this.enderecosNaoEncontrados.length === 0) return

            const data = this.enderecosNaoEncontrados.map((item, index) => ({
                'Nº': index + 1,
                'CNPJ': item.documento_formatado || '-',
                'Empresa': item.nome_empresa || '-',
                'Endereço completo': `${item.logradouro || ''}, ${item.numero || ''}, ${item.bairro || ''}, ${item.cidade || ''}, ${item.estado || ''}, ${item.cep || ''}`
            }))

            const nomeArquivo = 'enderecos_nao_encontrados.xlsx'

            this.$helpers.downloadArchiveXlsx(data, nomeArquivo)
        },
    }
}
</script>

<style scoped>
.filtros >>> .v-select .vs__selected,
.filtros >>> .v-select .vs__dropdown-option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filtros >>> .v-select {
  max-width: 100%;
}

.filtros >>> .v-select .vs__selected-options {
  flex: 1 1 auto;
  min-width: 0;
}

.filtros >>> .v-select .vs__selected {
  display: block;
  max-width: 90%;
}

@media (min-width: 992px) and (max-width: 1434px) {
  .filtros >>> .v-select .vs__selected {
    max-width: 80%;
  }
}

.filtros #search_companies {
  flex: 0 0 auto;
  white-space: nowrap;
}
</style>
